module.exports = __webpack_public_path__ + "static/HyGenius_App_DE-a6f9e76ea7f92814cd7e375b303e2c29.png";